import * as React from 'react';

interface ITextCellProps {
    onClick?: ((event: React.MouseEvent<HTMLDivElement>) => void);
    onDoubleClick?: ((event: React.MouseEvent<HTMLDivElement>) => void);
    value?: string;
}

export class TextCell extends React.Component<ITextCellProps, {}> {
    render() {
        const { value, onClick, onDoubleClick } = this.props;
        return (<div onClick={onClick} onDoubleClick={onDoubleClick} className="cell-value">{value}</div>);
    }
}
